import styled from 'styled-components';

export const ContainerMessage = styled.div`
  margin-top: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;
